import template from './placement-type.jade';
import validation from './../../../services/validation';
import options from '../../../enums/placement-type';

export default angular
    .module('cian.addForm.placementType', [])
    .directive('cianAfAboutObjectPlacementType', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';
            this.isMobile = deviceService.isMobile;
            this.items = options;

            this.validation = validation(this.form, 'placementType', {
                required: 'Укажите тип помещения',
            });
        },
        controllerAs: 'placementType',
        template,
    }))
    .name;
